// extracted by mini-css-extract-plugin
export default {"sum":"summary_sum__zRrkC","top":"summary_top__BZr28","title":"summary_title__kljdE","list":"summary_list__Omlt8"};